module.exports = __webpack_public_path__ + "static/media/left_lying.023f9ea7.png";